import { gql } from '@apollo/client';
import { CohortConfigFragment } from '../cohorts';
import {
  ExperimentFieldsFragment,
  MetricTypeFieldsFragment,
  SignificanceModeFieldsFragment,
  SignificanceTestFieldsFragment,
} from './fragments';
import { DatePickerFieldsFragment, SubjectFragment } from '../fragments';

export const SignificanceConfigFieldsFragment = gql`
  fragment SignificanceConfigFields on SignificanceConfig {
    cohortConfig {
      ...CohortConfigFields
    }
    defaultEnd
    defaultFormulaSamplingRate
    defaultMetric {
      ...MetricTypeFields
    }
    metrics {
      ...MetricTypeFields
    }
    defaultMode {
      ...SignificanceModeFields
    }
    modes {
      ...SignificanceModeFields
    }
    defaultStart
    defaultSubject {
      ...SubjectFields
    }
    subjects {
      ...SubjectFields
    }
    defaultTimeUnit
    experimentConfig {
      ...ExperimentFields
    }
    liveStartDate
    schema
    timeUnits
    timezone
    defaultTest {
      ...SignificanceTestFields
    }
    tests {
      ...SignificanceTestFields
    }
    defaultDatePicker {
      ...DatePickerFields
    }
  }
  ${CohortConfigFragment}
  ${MetricTypeFieldsFragment}
  ${SignificanceModeFieldsFragment}
  ${SubjectFragment}
  ${ExperimentFieldsFragment}
  ${SignificanceTestFieldsFragment}
  ${DatePickerFieldsFragment}
`;
